exports.list = {
    path: '/laporan_so',
    name: 'laporan_so', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_so/List.vue"),
}